import { isDefined } from 'aem-libs-ts/src/utils/common/isDefined'

import { FilterFnType, FormatValue, RenderValue, SelectItemType, SelectValueType } from './types'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isDefaultItem(item: any): item is SelectItemType {
  return item?.label && isDefined(item?.value)
}

export const defaultFilterFn: FilterFnType<SelectItemType> = (item, searchString) => {
  return item.label.toLowerCase().includes(searchString)
}

export const defaultFormatValueFn: FormatValue<SelectItemType, SelectValueType> = (item) => item.value

export const defaultRenderFn: RenderValue<SelectItemType> = (item) => {
  return item?.label ?? ''
}
